import React from 'react';
import './App.css';

import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import Main from './pages/main/Main';


function Layout() {
  return (
    <div id="app-container">
      <Outlet />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Main />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
